"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const theme_1 = __importDefault(require("../../styles/theme"));
const text_1 = __importStar(require("../text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const UserGreetingMessage = ({ firstName, profilePhoto }) => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.minimumMarginBetweenElementsVertically] },
    react_1.default.createElement(react_native_1.View, { style: [{ flex: 3, marginLeft: 30 }, styles_1.default.centerChildHorizontalVertical, { alignItems: 'flex-start' }] },
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true, style: textStyles_1.default.bold }, `Hello, ${firstName}`)),
    react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
        react_1.default.createElement(react_native_paper_1.Avatar.Image, { source: { uri: profilePhoto ? profilePhoto.uri : '' }, size: 48, style: [{ marginTop: 5, backgroundColor: theme_1.default.colors.COLOR_GRAY }] }))));
exports.default = UserGreetingMessage;
